import PropTypes from 'prop-types'
import {
  Button,
  HStack,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalOverlay,
  Text,
  VStack,
} from '@chakra-ui/react'
import React from 'react'
import { formatRut } from '../../../../utils/formats/formats'
import Arrow from '../../../../utils/assets/Arrow.svg'
import { REPOSITORY } from '../../../../api/repository/Repository'
import { useRequestStatusContext } from '../../../../utils/hooks/Context/RequestStatusContext'
import { useLoadingContext } from '../../../../utils/hooks/Context/LoadingContext'
import {
  approveReassignErrorsUpper,
  denyReassignErrorsUpper,
} from '../../../../variables/errors'
import { colors } from '../../../../utils/theme/styles'

export default function ReasignEnrollment({ data, isOpen, onClose }) {
  const {
    handleOpen,
    handleSetTitle,
    handleChangeBody,
    handleClose,
    handleChangeCustomColor,
  } = useRequestStatusContext()
  const { handleOpen: handleOpenLoading, handleClose: handleCLoseLoading } =
    useLoadingContext()

  const handleCloseResponse = () => {
    handleClose(location.reload())
  }

  const handleOkStatus = ({ status, title }) => {
    handleCLoseLoading()
    handleSetTitle(title, status)
    handleChangeBody(
      <Button
        variant="primary"
        onClick={status === 200 ? handleCloseResponse : handleClose()}
      >
        {status === 200 ? 'Continuar' : 'Contactar a soporte ahora'}
      </Button>,
    )
    handleOpen()
  }

  const handleConfirm = async () => {
    handleOpenLoading()
    onClose()
    await REPOSITORY.wsEmpresa.accounts.noNominative
      .approveReasign(data.nIdEnrolamiento)
      .then((res) => {
        const haveError =
          res.data.filter((el) =>
            approveReassignErrorsUpper.includes(el.sMensaje.toUpperCase()),
          ).length > 0
        handleOkStatus({
          status: haveError ? 500 : 200,
          title: haveError
            ? res.data[0].sMensaje
            : 'Bolsillo aprobado con éxito',
        })
        onClose()
      })
    handleCLoseLoading()
  }
  const handleDeny = async () => {
    handleOpenLoading()
    onClose()
    await REPOSITORY.wsEmpresa.accounts.noNominative
      .denyReasign(data.nIdEnrolamiento)
      .then((res) => {
        handleChangeCustomColor(colors.secondary.base)
        const haveError =
          res.data.filter((el) =>
            denyReassignErrorsUpper.includes(el.sMensaje.toUpperCase()),
          ).length > 0
        handleOkStatus({
          status: haveError ? 500 : 200,
          title: haveError
            ? res.data[0].sMensaje
            : 'Bolsillo rechazado con éxito',
        })
        onClose()
      })
    handleCLoseLoading()
  }
  return (
    <Modal size="2xl" isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalBody>
          <HStack
            width="100%"
            alignItems="center"
            justifyContent="space-between"
          >
            <VStack
              spacing="23px"
              borderWidth="1px 0px 1px 1px"
              borderStyle="dashed"
              borderColor="#EFA329"
              borderRadius="0px 5px 5px 0px"
              p={2}
            >
              <HStack justifyContent="space-between" w="100%">
                <Text variant="body4" fontWeight="bold">
                  RUT:
                </Text>

                <Text variant="body4" fontWeight="400">
                  {formatRut(data?.sRUT)?.formatValue}
                </Text>
              </HStack>
              <HStack justifyContent="space-between" w="100%">
                <Text variant="body4" fontWeight="bold">
                  Nombre:
                </Text>

                <Text variant="body4" fontWeight="400">
                  {`${data?.sNombre || ''} ${data?.sApellidoPaterno || ''}`}
                </Text>
              </HStack>
              <HStack justifyContent="space-between" w="100%">
                <Text variant="body4" fontWeight="bold">
                  Centro de costo:
                </Text>
                <Text variant="body4" fontWeight="400">
                  {data?.CentroCosto || 'Sin Asignar'}
                </Text>
              </HStack>
              <HStack justifyContent="space-between" w="100%">
                <Text variant="body4" fontWeight="bold">
                  Sucursal:
                </Text>
                <Text variant="body4" fontWeight="400">
                  {data?.Sucursal || 'Sin Asignar'}
                </Text>
              </HStack>
              <HStack justifyContent="space-between" w="100%">
                <Text variant="body4" fontWeight="bold">
                  Grupo:
                </Text>
                <Text variant="body4" fontWeight="400">
                  {data?.Grupo || 'Sin Asignar'}
                </Text>
              </HStack>
              <HStack justifyContent="space-between" w="100%">
                <Text variant="body4" fontWeight="bold">
                  Código de NN:
                </Text>
                <Text variant="body4" fontWeight="400">
                  {data?.sEmpleado}
                </Text>
              </HStack>
              <HStack justifyContent="space-between" w="100%">
                <Text variant="body4" fontWeight="bold">
                  Fecha:
                </Text>
                <Text variant="body4" fontWeight="400">
                  {data?.dFechaSolicitudAnterior}
                </Text>
              </HStack>
              <HStack justifyContent="space-between" w="100%">
                <Text variant="body4" fontWeight="bold">
                  Saldo:
                </Text>
                <Text variant="body4" fontWeight="400">
                  ${data?.nSaldo}
                </Text>
              </HStack>
            </VStack>
            <img alt="arrow" src={Arrow} />
            <VStack
              spacing="23px"
              borderWidth="1px 1px 1px 0px"
              borderStyle="dashed"
              borderColor="#EFA329"
              borderRadius="0px 5px 5px 0px"
              p={2}
            >
              <HStack justifyContent="space-between" w="100%">
                <Text variant="body4" fontWeight="bold">
                  RUT:
                </Text>

                <Text variant="body4" fontWeight="400">
                  {formatRut(data?.sRutWalletSolicitante || '')?.formatValue}
                </Text>
              </HStack>
              <HStack justifyContent="space-between" w="100%">
                <Text variant="body4" fontWeight="bold">
                  Nombre:
                </Text>
                <Text variant="body4" fontWeight="400">
                  {`${data?.sNombreSolicitante || ''} ${
                    data?.sApellidoPaternoSolicitante || ''
                  }`}
                </Text>
              </HStack>
              <HStack justifyContent="space-between" w="100%">
                <Text variant="body4" fontWeight="bold">
                  Centro de costo:
                </Text>
                <Text variant="body4" fontWeight="400">
                  {data?.CentroCosto || 'Sin Asignar'}
                </Text>
              </HStack>
              <HStack justifyContent="space-between" w="100%">
                <Text variant="body4" fontWeight="bold">
                  Sucursal:
                </Text>
                <Text variant="body4" fontWeight="400">
                  {data?.Sucursal || 'Sin Asignar'}
                </Text>
              </HStack>
              <HStack justifyContent="space-between" w="100%">
                <Text variant="body4" fontWeight="bold">
                  Grupo:
                </Text>
                <Text variant="body4" fontWeight="400">
                  {data?.Grupo || 'Sin Asignar'}
                </Text>
              </HStack>
              <HStack justifyContent="space-between" w="100%">
                <Text variant="body4" fontWeight="bold">
                  Código de NN:
                </Text>
                <Text variant="body4" fontWeight="400">
                  {data?.sEmpleado}
                </Text>
              </HStack>
              <HStack justifyContent="space-between" w="100%">
                <Text variant="body4" fontWeight="bold">
                  Fecha:
                </Text>
                <Text variant="body4" fontWeight="400">
                  {data?.dFechaSolicitudEnrolamiento}
                </Text>
              </HStack>
              <HStack justifyContent="space-between" w="100%">
                <Text variant="body4" fontWeight="bold">
                  Saldo:
                </Text>
                <Text variant="body4" fontWeight="400">
                  ${data?.nSaldo}
                </Text>
              </HStack>
            </VStack>
          </HStack>
        </ModalBody>
        <ModalFooter>
          <HStack
            width="100%"
            alignItems="center"
            gap={20}
            justifyContent="center"
          >
            <Button
              variant="white"
              borderRadius="6px"
              border="1px solid black"
              width="max-content"
              boxShadow="0px 12px 16px rgba(0, 0, 0, 0.25)"
              h="51px"
              onClick={handleDeny}
            >
              <Text color="black">RECHAZAR</Text>
            </Button>
            <Button
              variant="primary"
              borderRadius="6px"
              boxShadow="0px 12px 16px rgba(0, 0, 0, 0.25)"
              h="51px"
              width="max-content"
              onClick={handleConfirm}
            >
              <HStack>
                <Text color="white">APROBAR</Text>{' '}
              </HStack>
            </Button>
          </HStack>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}

ReasignEnrollment.propTypes = {
  data: PropTypes.shape({
    CentroCosto: PropTypes.string,
    Grupo: PropTypes.string,
    Sucursal: PropTypes.string,
    dFechaSolicitudAnterior: PropTypes.string,
    dFechaSolicitudEnrolamiento: PropTypes.string,
    nIdEnrolamiento: PropTypes.number,
    nSaldo: PropTypes.any,
    sApellidoPaterno: PropTypes.string,
    sApellidoPaternoSolicitante: PropTypes.string,
    sEmpleado: PropTypes.any,
    sGrupo: PropTypes.string,
    sNombre: PropTypes.string,
    sNombreSolicitante: PropTypes.string,
    sRUT: PropTypes.string,
    sRutWalletSolicitante: PropTypes.string,
  }),
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
}
